import React, { Component } from "react";
import "react-toggle/style.css";
import "rc-input-number/assets/index.css";
import styled from "styled-components";
import { connect } from "react-redux";
import { Row, Col } from "styled-bootstrap-grid";
import Toggle from "react-toggle";
import Footer from "../../../Shared/Footer";
import { getTimesheetData } from "../../../../Actions/TechnicianTimesheet";
import { saveTechnicianWorkHours } from "../../../../Actions/TechnicianTimesheet";
import { format } from "date-fns";
import { withRouter } from "react-router-dom";
import {
  TimeConverstion,
  GetTimeDateDiff,
} from "../../../../Api/Utils/ReuseableFunctions";
import { userDataTech } from "../../../../Actions/UserTechData";
import { withTranslation, Trans } from "react-i18next";
import { logoutUser, resetsaveTimesheetMessage } from "../../../../Actions";
import TimeInput from "../../../Shared/TimeInput";

class HoursLogin extends Component {
  date = format(new Date(), "dd/MM/yyyy");
  constructor(props) {
    super(props);
    this.data = {};
    this.changedValues = false;
    this.state = {
      formData: {
        actualBreakHour: 0,
        actualEndTime: "00:00",
        actualStartTime: "00:00",
        addtnlHours: 0,
        callOuts: [],
        comments: "",
        expectedBreakHour: 0,
        expectedEndTime: "00:00",
        expectedStartTime: "00:00",
        isCallOutOrRoadside: "N",
        shiftId: "",
        ssoId: "",
        isBeforeSubmitted: "N",
        actualPaidBreakHours: 0,
      },
      timeDiffrence: 0,
      extraAdjustment: false,
      changedValues: false,
    };
    this.expectedTimeDiff = 0;
    this.handleFormChange = this.handleFormChange.bind(this);
    this.calculateExpectedHours = this.calculateExpectedHours.bind(this);
  }

  componentDidMount() {
    this.props.dispatch(
      getTimesheetData({
        ssoId: this.props.ssoId,
        workshopLocation: this.props.branchId,
        timesheetDate: this.date,
      })
    );
  }

  handleFormChange(val, name) {
    let formData = JSON.parse(JSON.stringify(this.state.formData));
    formData[name] = val;
    this.setState(
      {
        formData,
      },
      () => {
        this.calculateExpectedHours();
      }
    );
  }

  calculateExpectedHours() {
    let formData = this.state.formData;
    if (this.props.security && this.props.security.enableBreaksCal === "Y") {
      formData = this.autoBreakCalculation(formData);
    }
    let actualTimeDiff =
      GetTimeDateDiff(formData.actualStartTime, formData.actualEndTime) -
      Number(formData.actualBreakHour);
    formData.addtnlHours = actualTimeDiff - this.expectedTimeDiff || 0;

    this.setState({
      formData,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.techData !== this.props.techData) {
      if (this.props.techData) {
        let techData = JSON.parse(JSON.stringify(this.props.techData));
        let formData = techData;
        this.expectedTimeDiff =
          GetTimeDateDiff(
            techData.expectedStartTime,
            techData.expectedEndTime
          ) - Number(techData.expectedBreakHour);

        this.setState({ formData }, () => {
          this.calculateExpectedHours();
        });
      }
      // this.calculateExpectedHours();
    }

    if (
      this.props.saveMessage !== void 0 &&
      this.props.saveMessage.type === "Timesheet Saved Successfully" &&
      this.props.saveMessage.message.errorCd === "SUCCESS"
    ) {
      let payload = {
        technicianId: this.props.ssoId,
        branchId: this.props.branchId,
        clckInOut: "OUT",
        reasonCd: "43",
        signedInBy: null,
        signedOutBy: this.props.ssoId,
        comments: null,
      };
      this.props.dispatch(logoutUser(payload));
      this.props.dispatch(resetsaveTimesheetMessage());
    }
  }

  nextStep = () => {
    let data = this.state.formData;
    this.props.dispatch(userDataTech(data));
    const { timeForTime } = this.props.security;
    if (
      data.addtnlHours !== this.props.techData.addtnlHours &&
      (timeForTime === "Y" || timeForTime === "B")
    ) {
      this.props.history.push("hoursadjustment&payment", {
        page: "additionalHours",
      });
    } else {
      if (this.props.security.timeForTime === "T") {
        data.paymentType = "T";
      }
      if (this.props.security.timeForTime === "N") {
        data.paymentType = "P";
      }
      this.props.history.push("callouts");
    }
  };

  submitData = () => {
    let data = this.state.formData;
    data.timesheetDate = format(new Date(), "dd/MM/yyyy");
    data.branchNumber = this.props.branchId;
    data.expectedBreakHour = Number(data.expectedBreakHour);
    data.actualPaidBreakHours = Number(data.timesheetActualPaidBreakHours);
    delete data["timesheetPaidBreakHours"];
    delete data["timesheetActualPaidBreakHours"];
    data.isBeforeSubmitted = "Y";
    data.maintainenceUser = this.props.ssoId;
    if (this.props.security.timeForTime === "T") {
      data.paymentType = "T";
    }
    if (this.props.security.timeForTime === "N") {
      data.paymentType = "P";
    }
    this.props.dispatch(saveTechnicianWorkHours(data));
  };
  autoBreakCalculation = (data) => {
    let actualTimeDiff = GetTimeDateDiff(
      data.actualStartTime,
      data.actualEndTime
    );

    if (actualTimeDiff > 0 && actualTimeDiff <= 540) {
      if (Number(data.actualBreakHour) > 30) {
        data.actualBreakHour = Number(data.actualBreakHour);
      } else {
        data.actualBreakHour = 30;
      }
    } else if (actualTimeDiff > 0 && actualTimeDiff > 540) {
      if (Number(data.actualBreakHour) > 45) {
        data.actualBreakHour = Number(data.actualBreakHour);
      } else {
        data.actualBreakHour = 45;
      }
    } else {
      data.actualBreakHour = 0;
    }
    return data;
  };
  render() {
    const { t, security } = this.props;
    const {
      actualStartTime,
      actualEndTime,
      actualBreakHour,
      addtnlHours,
      comments,
      expectedBreakHour,
      isBeforeSubmitted,
      isCallOutOrRoadside,
      timesheetPaidBreakHours,
      timesheetActualPaidBreakHours,
    } = this.state.formData;
    const { extraAdjustment, timeDiffrence } = this.state;
    var nextFlag =
      isCallOutOrRoadside === "Y" ||
      (this.props.techData &&
        addtnlHours !== this.props.techData.addtnlHours &&
        security &&
        (security.timeForTime === "Y" || security.timeForTime === "B"));

    return this.props.techData !== undefined && security && security.showMintInt ? (
      <>
        <ParentDiv>
          <MainRow>
            <MainCol offset="2" md="8">
              <ROW>
                <WorkingHeading>
                  <Trans>standardWorkingHours</Trans>
                </WorkingHeading>
              </ROW>
              <TimeROW>
                <COL md="3">
                  <Textspan>
                    <Trans>startTime</Trans>
                  </Textspan>
                  <Span>
                    {this.props.techData.expectedStartTime || "00:00"}
                  </Span>
                </COL>
                <COL md="3">
                  <Textspan>
                    <Trans>endTime</Trans>
                  </Textspan>
                  <Span>{this.props.techData.expectedEndTime || "00:00"}</Span>
                </COL>
                <COL md="3">
                  <Textspan>
                    <Trans>unpaidBreaksHours</Trans>
                  </Textspan>
                  <Span>{TimeConverstion(expectedBreakHour)}</Span>
                </COL>
                <COL md="3">
                  <Textspan>
                    <Trans>paidBreaksHours</Trans>
                  </Textspan>
                  <Span>{TimeConverstion(timesheetPaidBreakHours)}</Span>
                </COL>
              </TimeROW>
              {(extraAdjustment ||
                isBeforeSubmitted === "Y" ||
                addtnlHours !== 0) && (
                  <AdjustedTimming>
                    <WorkingHeading>
                      {" "}
                      <Trans>actualTimings</Trans>
                    </WorkingHeading>
                    <TimeROW>
                      <COL md="3">
                        <div className="field-label">
                          <Trans>startTime</Trans>
                        </div>
                        <TimeInput
                          target="actualStartTime"
                          time={actualStartTime || "00:00"}
                          setTime={this.handleFormChange}
                          showMinInt={security.showMintInt === "Y"}
                          branchId = {this.props.branchId}
                        />
                      </COL>
                      <COL md="3">
                        <div className="field-label">
                          <Trans>endTime</Trans>
                        </div>
                        <TimeInput
                          target="actualEndTime"
                          time={actualEndTime || "00:00"}
                          setTime={this.handleFormChange}
                          showMinInt={security.showMintInt === "Y"}
                          branchId = {this.props.branchId}
                        />
                      </COL>
                      <COL md="3">
                        <div className="field-label">
                          <Trans>unpaidBreaksHours</Trans>
                        </div>
                        <TimeInput
                          target="actualBreakHour"
                          time={actualBreakHour}
                          hours={true}
                          setTime={this.handleFormChange}
                          showMinInt={security.showMintInt === "Y"}
                        />
                      </COL>
                      <COL md="3">
                        <div className="field-label">
                          <Trans>paidBreaksHours</Trans>
                        </div>
                        <TimeInput
                          target="timesheetActualPaidBreakHours"
                          time={timesheetActualPaidBreakHours}
                          hours={true}
                          setTime={this.handleFormChange}
                          showMinInt={security.showMintInt === "Y"}
                        />
                      </COL>
                    </TimeROW>
                  </AdjustedTimming>
                )}
              <AdjustedTimming>
                <COL md="7">
                  {(extraAdjustment ||
                    isBeforeSubmitted === "Y" ||
                    timeDiffrence !== 0) && (
                      <>
                        <div className="field-label">
                          <Trans>adjustmentToExpectedHours</Trans>
                        </div>
                        <div className="time-diff">
                          {TimeConverstion(addtnlHours)}
                        </div>{" "}
                      </>
                    )}
                </COL>
                <Col md="1"></Col>
                <COL md="4">
                  <Textspan>
                    <Trans>callOutRoadsideHours</Trans>
                  </Textspan>
                  <ToggleButtonDiv>
                    <Togglebutton
                      defaultChecked={
                        this.props.techData.isCallOutOrRoadside === "Y"
                      }
                      icons={{ checked: "YES", unchecked: "NO" }}
                      name={"isCallOutOrRoadside"}
                      onChange={(event) => {
                        var val = event.target.checked ? "Y" : "N";
                        // this.setState({
                        //   extraAdjustment: event.target.checked,
                        // });
                        this.handleFormChange(val, event.target.name);
                      }}
                    />
                  </ToggleButtonDiv>
                </COL>
              </AdjustedTimming>
              <CommentsDiv>
                <Textspan>
                  <Trans>comments</Trans>
                </Textspan>

                <Comment
                  value={comments ? comments : ""}
                  //value={this.props.techData.comments}
                  placeholder={t("enterComments")}
                  name="comments"
                  onChange={(event) => {
                    this.handleFormChange(
                      event.target.value,
                      event.target.name
                    );
                  }}
                />
              </CommentsDiv>
            </MainCol>
          </MainRow>
          <Footer height={"120px"}>
            {isBeforeSubmitted === "N" &&
              !extraAdjustment &&
              isCallOutOrRoadside === "N" && (
                <ul>
                  <li>
                    <label>
                      <Trans>haveyoucompletedabovespecifiedhours</Trans>
                    </label>
                  </li>
                  <li>
                    <>
                      <Button onClick={this.submitData}>
                        <Trans>yes</Trans>
                      </Button>
                      <Button
                        onClick={() => {
                          this.setState({ extraAdjustment: true });
                        }}
                        Color={true}
                      >
                        <Trans>no</Trans>
                      </Button>
                    </>
                  </li>
                </ul>
              )}
            {nextFlag ? (
              <ul>
                <li>
                  <label />
                </li>
                <li>
                  <Button className="font-size" onClick={this.nextStep}>
                    <Trans>next</Trans>
                  </Button>
                </li>
              </ul>
            ) : (
                <ul>
                  <li>
                    <label />
                  </li>
                  <li>
                    <Button className="font-size" onClick={this.submitData}>
                      <Trans>submitAndLogout</Trans>
                    </Button>
                  </li>
                </ul>
              )}
          </Footer>
        </ParentDiv>
      </>
    ) : (
        <div />
      );
  }
}

const mapStateToProps = ({
  auth,
  userMessage,
  technicianTimesheet,
  userTechData,
  saveTechnicianTimesheet,
  fetchTimesheetSecurity,
}) => {
  return {
    isAuthenticated: auth.isAuthenticated,
    ssoId: auth.ssoId,
    message: userMessage,
    userDefault: auth.user.defaultProfile,
    techData: technicianTimesheet.payload,
    saveData: userTechData.payload,
    branchId: auth.user ? auth.user.defaultProfile.branchId : null,
    saveMessage: saveTechnicianTimesheet,
    security: fetchTimesheetSecurity.securityList,
  };
};

export default withRouter(
  connect(mapStateToProps)(withTranslation()(HoursLogin))
);

const ParentDiv = styled.div`
  font-family: Trebuchet MS;
  li {
    list-style: none;
  }
  label {
    padding-bottom: 10px;
    font-size: 18px;
  }
  .font-size {
    font-size: 13px;
  }
`;
const CommentsDiv = styled.div`
  padding-top :16px
  text-align:left
`;
const Comment = styled.input`
  width: 100%;
  border-top: none;
  border-right: none;
  border-left: none;
`;
const ToggleButtonDiv = styled.div`
  padding-top: 7px;
  .react-toggle--checked:hover:not(.react-toggle--disabled)
    .react-toggle-track {
    background-color: #00a6eb;
  }
  .react-toggle:hover:not(.react-toggle--checked) .react-toggle-track {
    background-color: #e0e0e0;
  }
  .react-toggle--checked .react-toggle-track {
    background-color: #00a6eb;
  }
  .react-toggle--checked .react-toggle-track-x {
    opacity: 0 !important;
  }
  .react-toggle--checked .react-toggle-thumb {
    left: 50px;
    border-color: #00a6eb;
  }
`;
const Togglebutton = styled(Toggle)`
  border-radius: 35px;
  font-size: 14px;
  .react-toggle-track {
    width: 81px;
    height: 34px;
    background-color: #e0e0e0;
  }
  .react-toggle-track-check {
    position: absolute;
    width: 14px;
    height: 10px;
    top: 8px;
    left: 14px;
    color: white;
  }
  .react-toggle-thumb {
    position: absolute;
    top: 4px;
    left: 5px;
    width: 26px;
    height: 26px;
    border: 1px solid #d9d9d9;
    border-radius: 50%;
    background-color: #fafafa;
    box-sizing: border-box;
    transition: all 0.15s ease;
  }
  .react-toggle-track-x {
    position: absolute;
    width: 10px;
    height: 10px;
    top: 8px;
    right: 25px;
    opacity: 1;
    transition: opacity 0.25s ease;
    color: white;
  }
  .react-toggle--checked .react-toggle-track-x {
    opacity: 0 !important;
  }
`;
const AdjustedTimming = styled(Row)`
  margin-left: 0px;
  margin-right: 0px;
  padding-top: 4%;
  position: relative;
  text-align: left;
  .time-diff {
    font-size: 24px;
    font-weight: bold;
  }
`;
const WorkingHeading = styled.div`
  font-size: 16px;
  color: #4a4a4a;
  font-weight: bold;
`;
const MainRow = styled(Row)`
  margin-left: 0px;
  margin-right: 0px;
`;
const MainCol = styled(Col)`
  padding-left: 0px;
  padding-right: 0px;
`;
const ROW = styled(Row)`
  margin-left: 0px;
  margin-right: 0px;
`;
const TimeROW = styled(Row)`
  margin-left: 0px;
  margin-right: 0px;
  text-align: left;
  padding-top: 10px;
  width: 100%;
`;
const COL = styled(Col)`
  padding-left:0px padding-right:0px text:align:left .field-label {
    display: block;
    font-size: 14px;
    line-height: 26px;
  }
`;
const Textspan = styled.span`
  font-size: 14px;
  color: #4a4a4a;
`;
const Span = styled.span`
  display: block;
`;
const Button = styled.button`
  background: ${(props) => (props.Color ? "#e1e5eb" : "#c4151c")};
  border-radius: 30px;
  padding: 0;
  border: ${(props) => (props.Color ? "1px solid #96989a;" : "none")};
  height: 40px;
  width: 150px;
  color: ${(props) => (props.Color ? "#939292;" : "#ffffff")};
  font-weight: 50;
  position: relative;
  left: 0px;
  font-size: 16px;
  margin-left: 10px;
  margin-right: 10px;
`;
